const inline = (text) => {
  const parts = [];
  let rest = text;
  let key = 0;
  while (rest.length) {
    const bold = rest.match(/\*\*(.+?)\*\*/);
    const link = rest.match(/\[([^\]]+)\]\(([^)]+)\)/);
    const first = [bold, link].filter(Boolean).sort((a, b) => a.index - b.index)[0];
    if (!first) {
      parts.push(rest);
      break;
    }
    if (first.index > 0) parts.push(rest.slice(0, first.index));
    if (first === bold) {
      parts.push(<strong key={key++} className="font-semibold text-ink">{first[1]}</strong>);
    } else {
      const href = first[2];
      const external = href.startsWith("http");
      parts.push(
        <a
          key={key++}
          href={href}
          {...(external ? { target: "_blank", rel: "noreferrer" } : {})}
          className="underline decoration-cobalt underline-offset-4 transition-colors hover:text-cobalt"
        >
          {first[1]}
        </a>
      );
    }
    rest = rest.slice(first.index + first[0].length);
  }
  return parts;
};

export function Markdown({ text, className = "" }) {
  const lines = text.split("\n");
  const blocks = [];
  let list = null;
  let key = 0;

  const flushList = () => {
    if (list && list.length) {
      blocks.push(
        <ul key={key++} className="my-4 space-y-2">
          {list.map((item, i) => (
            <li key={i} className="flex items-baseline gap-3">
              <span className="inline-block h-1.5 w-1.5 shrink-0 translate-y-[-2px] rounded-full bg-cobalt/70" aria-hidden="true" />
              <span>{inline(item)}</span>
            </li>
          ))}
        </ul>
      );
    }
    list = null;
  };

  for (const raw of lines) {
    const line = raw.trimEnd();
    if (line.startsWith("- ")) {
      list = list || [];
      list.push(line.slice(2));
      continue;
    }
    flushList();
    if (!line.trim()) continue;
    if (line.startsWith("### ")) {
      blocks.push(<h3 key={key++} className="mt-8 text-lg font-semibold tracking-tight text-ink">{inline(line.slice(4))}</h3>);
    } else if (line.startsWith("## ")) {
      blocks.push(<h2 key={key++} className="mt-12 border-t border-ink/10 pt-8 text-2xl font-semibold tracking-tight text-ink">{inline(line.slice(3))}</h2>);
    } else if (line.startsWith("# ")) {
      blocks.push(<h1 key={key++} className="mt-12 text-3xl font-semibold tracking-tight text-ink first:mt-0">{inline(line.slice(2))}</h1>);
    } else {
      const segs = line.split(/<br\s*\/?>/);
      blocks.push(
        <p key={key++} className="my-4">
          {segs.map((seg, i) => (
            <span key={i}>{i > 0 && <br />}{inline(seg)}</span>
          ))}
        </p>
      );
    }
  }
  flushList();

  return <div className={`text-base leading-relaxed text-ink/70 ${className}`}>{blocks}</div>;
}
